import type {AddFileOptions} from '@uppy/core';
import type {UppyFileMeta} from '../../types';

/**
 * Get an `UppyFile` object from a standard `File` object\
 * Useful for when adding `File`s to uppy
 * @param file File
 * @param meta Any meta to set on the `UppyFile` object
 * @returns `UppyFile` object
 * @example
 * 	...
 * 	onFilesDropped((files: File[]) => {
 * 		uppy.addFiles(files.map(file => getUppyFileObjectFromFile(file)));
 * 	}),
 * 	...
 */
export const getUppyFileObjectFromFile = <
	TMeta extends Partial<UppyFileMeta> = Partial<UppyFileMeta>,
>(
	file: File,
	meta?: TMeta,
): AddFileOptions<TMeta> => ({
	name: file.name,
	type: file.type,
	data: file,
	size: file.size,
	meta: {
		// path of the file relative to the ancestor directory the user selected.
		// e.g. 'docs/Old Prague/airbnb.pdf'
		relativePath: (file as any).relativePath || file.webkitRelativePath || null,
		...meta,
	} as AddFileOptions<any>['meta'],
});
